import { observer } from 'mobx-react-lite';
import TopNav from './TopNav';
import type { TopNavProps, TopNavValueProps } from './types';

export type { TopNavProps, TopNavValueProps };
export default observer(TopNav); // MANUAL OVERRIDE
